import { apiDelete, apiGet, apiPost, apiPut, API_URI } from "api";
import { AddActivityRequest } from "../types/AddActivityRequest";

const ticket = {
    get: async (id: number) => {
        const data = await apiGet(`${API_URI}/api/ticket/${id}`);
        return data;
    },
    getAll: async (clientId: number) => {
        const data = await apiGet(`${API_URI}/api/ticket?clientId=${clientId}`);
        return data;
    },
    add: async (ClientId: number, BoardId: number, Title: string, Description: string, DueDate: string, Position: number) => {
        const data = apiPost(`${API_URI}/api/ticket`, {
            ClientId: ClientId,
            BoardId: BoardId,
            Heading: Title,
            Description: Description,
            DueDate: DueDate.length > 0 ? DueDate : null,
            Position: Position,
        });
        return data;
    },
    duplicate: async (request: { Id: number; DuplicationAmount: number }) => {
        const data = apiPost(`${API_URI}/api/ticket/duplicate`, request);
        return data;
    },
    copy: async (request: { Id: number; BoardId: number }) => {
        const data = apiPost(`${API_URI}/api/ticket/copy`, request);
        return data;
    },
    archive: async (ticketId: number, contactId: number) => {
        const data = apiPut(`${API_URI}/api/ticket/archive/${ticketId}/${contactId}`);
        return data;
    },
    UnArchive: async (ticketId: number, contactId: number) => {
        const data = apiPut(`${API_URI}/api/ticket/unarchive/${ticketId}/${contactId}`);
        return data;
    },
    archiveMultiple: async (tickets: number[], contactId: number) => {
        const data = apiPost(`${API_URI}/api/ticket/archive/multiple/${contactId}`, tickets);
        return data;
    },
    update: async (id: number, contactId: number, heading: string, description: string, dueDate: string) => {
        const data = await apiPut(`${API_URI}/api/ticket/${id}/${contactId}`, {
            Heading: heading,
            DueDate: dueDate,
            Description: description,
        });

        return data;
    },
    delete: async (id: number, contactId: number) => {
        const data = await apiDelete(`${API_URI}/api/ticket/${id}/${contactId}`);
        return data;
    },
    updatePosition: async (id: number, clientId: number, columnId: number, position: number) => {
        const data = await apiPut(`${API_URI}/api/ticket/${id}/position?clientId=${clientId}&columnId=${columnId}&position=${position}`);
        return data;
    },
    assign: async (ticketId: number, assigneeId: number) => {
        const data = await apiPut(`${API_URI}/api/ticket/assign?ticketId=${ticketId}&assigneeId=${assigneeId}`);
        return data;
    },
    unAssign: async (ticketId: number) => {
        const data = await apiPut(`${API_URI}/api/ticket/assign?ticketId=${ticketId}&assigneeId=`);
        return data;
    },
    member: {
        add: async (ticketId: number, contactId: number) => {
            const data = await apiPost(`${API_URI}/api/ticketmember/insert?ticketId=${ticketId}&contactId=${contactId}`);
            return data;
        },
        remove: async (ticketId: number, contactId: number) => {
            const data = await apiDelete(`${API_URI}/api/ticketmember/delete/${ticketId}/${contactId}/${contactId}`);
            return data;
        },
    },
    complete: async (ticketId: number, contactId: number, isCompleted: boolean) => {
        const data = await apiPut(`${API_URI}/api/ticket/complete/${ticketId}/${contactId}/${isCompleted}`);
        return data;
    },
    label: {
        getAll: async (ticketId: number) => {
            const data = await apiGet(`${API_URI}/api/ticketlabel/${ticketId}`);
            return data;
        },
        add: async (ticketId: number, contactId: number, description: string, colour: string) => {
            const data = await apiPost(`${API_URI}/api/ticketlabel/${contactId}`, {
                ticketId: ticketId,
                description: description,
                colour: colour === "" ? "FFF" : colour,
            });
            return data;
        },
        delete: async (id: number) => {
            const data = await apiDelete(`${API_URI}/api/ticketlabel/${id}`);
            return data;
        },
    },
    checklist: {
        get: async (ticketId: number) => {
            const data = apiGet(`${API_URI}/api/checklist?ticketId=${ticketId}`);
            return data;
        },
        add: async (ticketId: number, description: string) => {
            const data = await apiPost(`${API_URI}/api/checklist`, {
                TicketId: ticketId,
                Description: description,
            });
            return data;
        },
        item: {
            // add: async (checklistId: number, description: string) => {
            //     const data = await apiPost(`${API_URI}/api/checklist/${checklistId}/item`, {
            //         TicketId: 0,
            //         description: description
            //     });
            //     return data;
            // },
            add: async (ticketId: number, contactId: number, val: string) => {
                const data = await apiPost(`${API_URI}/api/checklist/item`, { TicketId: ticketId, ContactId: contactId, Value: val });
                return data;
            },
            remove: async (id: number, ticketId: number, contactId: number) => {
                const data = await apiDelete(`${API_URI}/api/checklist/item/${id}/${ticketId}/${contactId}`);
                return data;
            },
            complete: async (id: number, ticketId: number, isCompleted: boolean) => {
                const data = await apiPut(`${API_URI}/api/checklist/item/${id}/${ticketId}/complete/${isCompleted}`);
                return data;
            },
            move: async (id: number, position: number) => {
                const data = await apiPut(`${API_URI}/api/checklist/item/move/${id}/${position}`);
                return data;
            },
        },
    },
    attachment: {
        getAll: async (ticketId: number) => {
            const data = await apiGet(`${API_URI}/api/ticket/${ticketId}/attachment`);
            return data;
        },
        add: async (ticketId: number, contactId: number, file: File) => {
            const formData = new FormData();
            formData.append("file", file);

            const data = await fetch(`${API_URI}/api/ticket/${ticketId}/${contactId}/attachment`, {
                method: "POST",
                body: formData,
                headers: {
                    Authorization: `Bearer ${localStorage.AccessToken}`,
                },
            });
            return data;
        },
        remove: async (id: number, ticketId: number) => {
            const data = await apiDelete(`${API_URI}/api/ticket/attachment/${id}/${ticketId}`);
            return data;
        },
    },
    activity: {
        getAll: async (ticketId: number) => {
            const data = await apiGet(`${API_URI}/api/ticket/activity/${ticketId}`);
            return data;
        },
    },
    comment: {
        add: async (clientId: number, ticketId: number, comment: string) => {
            const data = await apiPost(`${API_URI}/api/ticket/comment`, {
                ClientId: clientId,
                TicketId: ticketId,
                Comment: comment,
            });
            return data;
        },
        addActivity: async (request: AddActivityRequest) => {
            const data = await apiPost(`${API_URI}/api/ticket/comment/add`, request);
            return data;
        },
        remove: async (id: number) => {
            const data = await apiDelete(`${API_URI}/api/ticket/comment/${id}`);
            return data;
        },
    },
};

export default ticket;
